<template>
  <div></div>
</template>
<script>
export default {
  props: ['form', 'errors']
}
</script>
<style lang="scss" scoped></style>
